const BRANDING_SESSION_PREFIX = "wl:branding:v1:";

export const brandingSessionKey = (host) =>
  `${BRANDING_SESSION_PREFIX}${String(host || "matrix").trim().toLowerCase()}`;

export const loadBrandingSession = (host) => {
  try {
    const raw = sessionStorage.getItem(brandingSessionKey(host));
    if (!raw) return null;
    const parsed = JSON.parse(raw);
    return parsed && typeof parsed === "object" ? parsed : null;
  } catch {
    return null;
  }
};

export const saveBrandingSession = (host, options) => {
  if (!options || typeof options !== "object") return;
  try {
    sessionStorage.setItem(
      brandingSessionKey(host),
      JSON.stringify({
        ...options,
        resolved_host:
          options.resolved_host ||
          String(host || "").trim().toLowerCase() ||
          null,
        _branding_saved_at: Date.now(),
      }),
    );
  } catch {
    // ignore quota / private mode
  }
};

export const clearBrandingSession = (host) => {
  try {
    sessionStorage.removeItem(brandingSessionKey(host));
  } catch {
    // ignore
  }
};

export const persistBrandingForHost = (options, fallbackHost = "") => {
  if (!options) return;
  const host =
    String(options.resolved_host || "").trim().toLowerCase() ||
    String(fallbackHost || "").trim().toLowerCase() ||
    "matrix";
  saveBrandingSession(host, options);
};
